import { axiosClient } from './axios_client';
import axios from 'axios';
import { API_BASE_URL } from '../config';

/**
 * Xác thực token
 */
function verify() {
  return axiosClient.post('/api/auth/verify');
}

/**
 * Lấy thông tin user hiện tại
 */
function getMe() {
  return axiosClient.get('/api/auth/me');
}

/**
 * Đăng nhập - Verify token và sync user (sau khi đã có Firebase token)
 * @param {Object} userData - Optional: { email, uid, displayName, photoURL } for fallback
 */
function login(userData = null) {
  if (userData) {
    // Sử dụng axios trực tiếp để gửi cả body (không qua interceptor)
    const token = window.localStorage.getItem("api-token");
    
    return axios.post(
      `${API_BASE_URL}/api/auth/verify-login`,
      userData,
      {
        headers: {
          'x-firebase-idtoken': token,
          'Content-Type': 'application/json'
        }
      }
    ).then(res => res.data);
  } else {
    return axiosClient.post('/api/auth/verify-login');
  }
}

/**
 * Cập nhật thông tin profile
 * @param {Object} profileData - { displayName?: string, photoURL?: string, phoneNumber?: string }
 */
function updateProfile(profileData) {
  // axiosClient interceptor đã trả về response.data, nên không cần .data nữa
  return axiosClient.put('/api/auth/profile', profileData);
}

/**
 * Kiểm tra user có mật khẩu hay không
 */
function checkPassword() {
  return axiosClient.get('/api/auth/profile/check-password');
}

/**
 * Cập nhật mật khẩu
 * @param {Object} passwordData - { oldPassword?: string, newPassword: string, confirmPassword: string }
 */
function updatePassword(passwordData) {
  return axiosClient.put('/api/auth/profile/password', passwordData);
}

/**
 * Đăng nhập với email/password (gọi trực tiếp backend login API)
 * @param {Object} loginData - { email: string, password: string, deviceToken?: string, deviceInfo?: object }
 */
function loginWithPassword(loginData) {
  // Sử dụng axios trực tiếp (không qua interceptor) vì chưa có token
  return axios.post(
    `${API_BASE_URL}/api/auth/login`,
    loginData,
    {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  ).then(res => res.data);
}

export const auth_api = {
  verify,
  getMe,
  login,
  loginWithPassword,
  updateProfile,
  checkPassword,
  updatePassword
};

